export enum EmployeeCalendarRegisterRelatableType {
  CompanyProduct = 'App\\Models\\CompanyProduct',
  CompanyProductPhase = 'App\\Models\\CompanyProductPhase',
}
